/**
 * 사용자 관련 리듀서
 */
import { SET_USER, CLEAR_USER, UPDATE_USER_PROFILE } from '../actions/actionTypes.js';

// 초기 상태
const initialState = {
  currentUser: null,
  isAuthenticated: false,
  profile: {},
  followings: [],
  followers: []
};

/**
 * 사용자 리듀서 함수
 * @param {Object} state - 현재 상태
 * @param {Object} action - 액션 객체
 * @returns {Object} 새로운 상태
 */
export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        currentUser: action.payload,
        isAuthenticated: true
      };
    
    case CLEAR_USER:
      return {
        ...initialState
      };
    
    case UPDATE_USER_PROFILE:
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload
        }
      };
    
    default:
      return state;
  }
}; 